import { render, staticRenderFns } from "./CustomerACT.vue?vue&type=template&id=45a05b23&functional=true&"
import script from "./CustomerACT.vue?vue&type=script&lang=js&"
export * from "./CustomerACT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports